import { Flex, Image, Text } from '@chakra-ui/react';
import HeaderCell from '../../components/table/HeaderCell';
import { formatCurrency } from '../../utils/formatCurrency';

const getStatusColor = status => {
  switch (status?.toLowerCase()) {
    case 'multiple':
      return '#456EFF';
    case 'shopify':
      return '#00FF38';
    case 'sold':
      return '#FF0000';
    case 'photo':
      return '#FFC700';
    case 'hidden':
      return '#74787B';
    case 'rejected':
      return '#B92C53';
    case 'dry cleaning':
      return '#5450A3';
    default:
      return '#FFC700';
  }
};

const getStatusBackgroundColor = status => {
  switch (status?.toLowerCase()) {
    case 'multiple':
      return '#456EFF1A';
    case 'shopify':
      return '#00FF3810';
    case 'sold':
      return '#FF000016';
    case 'photo':
      return '#FFC70016';
    case 'hidden':
      return '#74787B10';
    case 'rejected':
      return '#B92C5316';
    case 'dry cleaning':
      return '#5450A310';
    default:
      return '#FFC70010';
  }
};

const columns = [
  {
    name: <HeaderCell label={'TRANSACTION ID'} />,
    selector: row => row?.id, // Using `id` as SKU

    width: '200px',
  },
  {
    name: <HeaderCell label={'SKU'} />,
    selector: row => {
      const { product, variant_id, instance_id } = row;
      if (!product?.variants?.length) return '';
      // Find the variant that matches transaction.variant_id
      const matchedVariant = product.variants.find(v => v._id === variant_id);
      if (!matchedVariant) return '';
      // Find the instance that matches transaction.instance_id
      const matchedInstance = matchedVariant.instances.find(
        i => i._id === instance_id
      );
      // If both match → return SKU
      if (matchedInstance) {
        return matchedVariant.sku;
      }

      return '';
    },
  },
  {
    name: <HeaderCell label={'PRODUCT TITLE'} />,
    selector: row => row?.product?.product_title, // Using `id` as SKU
    width: '200px',
  },
  {
    name: <HeaderCell label={'PRODUCT STATUS'} />,
    selector: row => {
      const { product, variant_id, instance_id } = row;

      if (!product?.variants?.length) return '';

      const matchedVariant = product.variants.find(v => v._id === variant_id);
      if (!matchedVariant) return '';

      const matchedInstance = matchedVariant.instances.find(
        i => i._id === instance_id
      );
      if (!matchedInstance) return '';

      const status = matchedInstance.status;

      return (
        <span
          style={{
            display: 'inline-block',
            color: getStatusColor(status),
            backgroundColor: getStatusBackgroundColor(status),
            borderRadius: '50px',
            width: '110px',
            height: '28px',
            textAlign: 'center',
            lineHeight: '28px',
            fontSize: '14px',
            fontWeight: '500',
            fontFamily: 'PlusJakartaSansRegular',
            textTransform: 'capitalize',
          }}
        >
          {status === 'dry-cleaning'
            ? 'Dry Cleaning'
            : status === 'shopify'
            ? 'Live'
            : status}
        </span>
      );
    },
    width: '200px',
  },
  {
    name: <HeaderCell label={'SELLER NAME'} />,
    selector: row =>
      `${row?.affected_seller_id?.first_name} ${row?.affected_seller_id?.surname}`,
    width: '200px',
  },
  {
    name: <HeaderCell label={'SELLER ID'} />,
    selector: row => `${row?.affected_seller_id?.id}`,
    width: '150px',
  },
  {
    name: <HeaderCell label={'TRANSACTION TYPE'} />,
    selector: row => {
      const name = row?.transaction_type_id?.name;
      switch (name) {
        case 'return-cost':
          return 'Return Cost';
        case 'refund':
          return 'Refunded';
        case 'seller-commission':
          return 'Seller Commission';
        case 'seller_commission':
          return 'Seller Commission';
        case 'dry-cleaning-cost':
          return 'Dry Cleaning Cost';
        case 'dry-cleaning-cost-removed':
          return 'Dry Cleaning Cost Removed';
        default:
          return name;
      }
    },
    width: '300px',
  },
  {
    name: <HeaderCell label={'AMOUNT'} />,
    selector: row => {
      const { amount, product, variant_id, instance_id } = row;

      // Case 1: transaction already has amount
      if (amount !== undefined && amount !== null) {
        return formatCurrency(amount);
      }

      //  Case 2: fallback to matched instance return_cost
      if (!product?.variants?.length) return formatCurrency(0);

      // Find correct variant
      const matchedVariant = product.variants.find(v => v._id === variant_id);
      if (!matchedVariant) return formatCurrency(0);

      // Find correct instance
      const matchedInstance = matchedVariant.instances.find(
        i => i._id === instance_id
      );
      if (!matchedInstance) return formatCurrency(0);

      return formatCurrency(matchedInstance.return_cost ?? 0);
    },
    width: '200px',
  },
  // {
  //   name: <HeaderCell label={'BALANCE'} />,
  //   selector: row => {
  //     const name = row?.transaction_type_id?.name;
  //     const balance = row?.balance_after ?? 0;

  //     // format to 2 decimals always
  //     const formattedBalance = Math.abs(balance).toFixed(2);

  //     const isNegative = name === 'dry-cleaning-cost' || name === 'return-cost';
  //     const isPositive =
  //       name === 'seller-commission' || name === 'seller_commission';

  //     if (isNegative) {
  //       return (
  //         <Flex alignItems={'center'} gap={1}>
  //           <Text color={'#FF0000'}>£{formattedBalance}</Text>
  //           <Image
  //             width={5}
  //             height={5}
  //             src={require('../../assets/svgs/ArrowDownNegative.svg').default}
  //             _hover={{ cursor: 'pointer' }}
  //           />
  //         </Flex>
  //       );
  //     }

  //     if (isPositive) {
  //       return (
  //         <Flex alignItems={'center'} gap={1}>
  //           <Text color={'#00B85E'}>£{formattedBalance}</Text>
  //           <Image
  //             width={5}
  //             height={5}
  //             src={require('../../assets/svgs/Arrow.svg').default}
  //             _hover={{ cursor: 'pointer' }}
  //           />
  //         </Flex>
  //       );
  //     }

  //     // default case
  //     return `£${formattedBalance}`;
  //   },
  //   width: '200px',
  // },
];

const data = [
  {
    transactionId: 'TXN123456',
    sku: '001234',
    productTitle: 'Tots Onesie',
    productStatus: 'Live',
    sellerName: 'Cozy Critters',
    transactionType: 'Dry Cleaning Cost',
    amount: '£3.95',
    balance: '£13,200',
    balanceChange: 'down',
  },
  {
    transactionId: 'TXN123456',
    sku: '001235',
    productTitle: 'Sprouts Romper',
    productStatus: 'Rejected',
    sellerName: 'Sprout Styles',
    transactionType: 'Return Cost',
    amount: '£2.95',
    balance: '£13,200',
    balanceChange: 'down',
  },
  {
    transactionId: 'TXN123456',
    sku: '001236',
    productTitle: 'Cuddle Pajamas',
    productStatus: 'Sold',
    sellerName: 'Snuggle Bug',
    transactionType: 'Seller Commission',
    amount: '£200',
    balance: '£22,450',
    balanceChange: 'up',
  },
  {
    transactionId: 'TXN123456',
    sku: '001237',
    productTitle: 'Bunny Dress',
    productStatus: 'Hidden',
    sellerName: 'Bunny Wear',
    transactionType: 'Dry Cleaning Cost',
    amount: '£3.95',
    balance: '£10,000',
    balanceChange: 'down',
  },
  {
    transactionId: 'TXN123456',
    sku: '001238',
    productTitle: 'Pals T-Shirt',
    productStatus: 'Preview',
    sellerName: 'Friendly Tees',
    transactionType: 'Seller Commission',
    amount: '£3.95',
    balance: '£15,750',
    balanceChange: 'up',
  },
];

export { data, columns };
